import * as Constants from "../../constants";
import axios from 'axios';

export class LocationGeocode  {
    
    key: string = '';
    constructor() {
        this.key = Constants.KEY_GEOCODE ?? '';
    }

    forward (place : string) {
        return  axios.get("https://us1.locationiq.com/v1/search.php?key=" + this.key + "&q=" + encodeURI(place) + "&format=json&limit=1")
    }
    
    reverse (lat : string | number, lon: string | number) {
        return  axios.get("https://us1.locationiq.com/v1/reverse.php?key=" + this.key + "&lat=" + lat + "&lon=" + lon + "&format=json&limit=1")
    }

    //Forward geocoding to Stadia and returns result lat/lon to callback
//Arguments: place - String, callback - Function
    async forwardStadia  (place: string, key: string|null) {
        try{
            const response = await axios.get(`${Constants.GEOCODE_API_URL}?key=${key}&type=forward&place=${encodeURI(place)}`)
            const data = response.data;
            if (data && data.features && data.features.length && data.features[0] && data.features[0].geometry && data.features[0].geometry.coordinates) {
                let lat = data.features[0].geometry.coordinates[1];
                let lon = data.features[0].geometry.coordinates[0];

                if(lat && lon){
                    return {lat: lat, lon: lon};
                }
            }
            return null;
        }catch (e){
            return null;
        }
       
    }

//Reverse geocoding to Stadia and returns result label to callback
//Arguments: lat - Number, lon - Number, callback - Function
    async reverseStadia (lat: number, lon: number, key: string|null) {
        
        try{
            const response = await axios.get(`${Constants.GEOCODE_API_URL}?key=${key}&type=reverse&lat=${lat}&lon=${lon}`)
            const data = response.data;

            if(data && data.features && data.features.length && data.features[0] && data.features[0].properties && data.features[0].properties.label){
                let label = data.features[0].properties.label;
                if (label) {
                    return label;
                }
            }
            return '';
        }catch (e) {
            return '';
        }
        
    }
    
}
